"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const calculateScaledProgressMeasure_1 = require("../../evaluate/helpers/calculateScaledProgressMeasure");
const parseIntSafe_1 = require("../../helpers/parseIntSafe");
const entity_1 = require("../../type/entity");
function updateProgressMeasureAndCompletionStatusForScormCard(content, scormDataObject, state) {
    const lessonStatus = scormDataObject.lesson_status;
    if (['completed', 'passed', 'failed'].includes(lessonStatus)) {
        state.progressMeasure = 1;
        scormDataObject.progress_measure = '1.0';
        state.completionStatus = entity_1.CompletionStatus.COMPLETE;
        const offerType = content.offerType;
        if (offerType === entity_1.ContentType.ASSIGNMENT_CARD) {
            state.actualSubmit = true;
            state.submissionCount = 1;
        }
    }
    else {
        scormDataObject.progress_measure = (state.progressMeasure || 0).toString();
        state.completionStatus = entity_1.CompletionStatus.INCOMPLETE;
    }
    state.progressMeasure = parseIntSafe_1.parseIntSafe(scormDataObject.progress_measure);
    state.scaledProgressMeasure = calculateScaledProgressMeasure_1.calculateScaledProgressMeasure(content.minProgressMeasure || 0, state.progressMeasure);
}
exports.updateProgressMeasureAndCompletionStatusForScormCard = updateProgressMeasureAndCompletionStatusForScormCard;
//# sourceMappingURL=updateProgressMeasureAndCompletionStatusForScormCard.js.map